function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcEmptyCart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264.697,
    height: 196.139,
    viewBox: "0 0 264.697 196.139",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "xsvereckla"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 539",
    style: {
      fill: "none"
    },
    d: "M0 0h264.697v196.138H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1096"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1095",
    style: {
      clipPath: "url(#xsvereckla)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2945",
    d: "M431.878 216.588H298.087a29.246 29.246 0 0 1 0-58.492h133.79a29.246 29.246 0 1 1 0 58.492",
    transform: "translate(-217.678 -128.009)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2946",
    d: "M244.226 717.325H50.527a22.286 22.286 0 0 1 0-44.573h193.7a22.286 22.286 0 0 1 0 44.573",
    transform: "translate(-22.866 -544.721)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2947",
    d: "M496.371 504.843q-.7.053-1.412.052h-127.7a19.722 19.722 0 0 1 0-39.444h127.7q.714 0 1.412.051a19.721 19.721 0 0 0 0 39.341",
    transform: "translate(-281.392 -376.872)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2948",
    d: "m79.793 523.3-64.339 47.23A9.709 9.709 0 0 1 0 562.7v-97.966z",
    transform: "translate(0 -376.291)",
    style: {
      fill: "#9a9a9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2949",
    d: "M159.587 251.4v130.705a9.709 9.709 0 0 1-15.454 7.828l-64.34-47.227L0 284.138V251.4a9.71 9.71 0 0 1 9.709-9.709h140.168a9.71 9.71 0 0 1 9.709 9.709",
    transform: "translate(0 -195.695)",
    style: {
      fill: "#b8b8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2950",
    d: "M440.979 251.4v36.64a80.884 80.884 0 0 1-93.448-46.349h83.739a9.71 9.71 0 0 1 9.709 9.709",
    transform: "translate(-281.392 -195.695)",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2951",
    d: "M639.769 429.786v61.133a33.354 33.354 0 1 1 0-61.133",
    transform: "translate(-480.183 -345.737)",
    style: {
      fill: "#5d5d5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2952",
    d: "M593.046 427.169a33.355 33.355 0 1 0 33.354-33.355 33.355 33.355 0 0 0-33.355 33.355",
    transform: "translate(-480.183 -318.868)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2953",
    d: "M742.5 484.7v16.64c0 5.254-1.579 9.673-8.335 9.673-6.248 0-7.946-4.359-7.946-9.613v-16.315c0-6.016 2.588-9.6 8.248-9.6 5.552 0 8.034 3.495 8.034 9.222m-10.872-.275v17.608c0 2.59.777 3.994 2.738 3.994s2.678-1.455 2.678-4.148v-17.593c0-2.4-.753-3.832-2.684-3.832-1.844 0-2.731 1.268-2.731 3.967",
    transform: "translate(-588.012 -384.992)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2954",
    d: "M631.352 76.281a145.1 145.1 0 0 1-61.6-13.6c-6.38 5.658-15.46 8.681-27.022 8.989-16.279.431-33.346-5.05-50.721-16.3-12.579-8.145-25.058-19.1-37.092-32.548a1.332 1.332 0 0 1 1.986-1.776c19.688 22.008 50.111 47.985 83.995 47.985.587 0 1.172-.008 1.761-.023 10.35-.276 18.659-2.938 24.467-7.591q-1.521-.753-2.927-1.494a118.435 118.435 0 0 1-23.278-15.836 70.708 70.708 0 0 1-14.438-16.9c-4.451-7.7-5.341-14.653-2.5-19.567C525.978 4.142 530.852 0 542.69 0c9.767 0 19.035 4.553 26.1 12.821A43.413 43.413 0 0 1 579.274 39.9c.109 8.189-2.477 15.345-7.493 20.783a142.491 142.491 0 0 0 59.57 12.932h.077a1.332 1.332 0 0 1 0 2.664zM542.69 2.667c-8.363 0-14.037 2.171-16.408 6.279-2.34 4.055-1.451 10.057 2.5 16.9 6.466 11.19 20.166 23.045 36.648 31.713q1.815.955 3.828 1.934c4.876-4.891 7.456-11.522 7.349-19.557-.235-17.628-14.224-37.27-33.921-37.27",
    transform: "translate(-368.063 -.003)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2955",
    d: "M379.7 15.587a1.329 1.329 0 0 1-1.031-.487c-6.236-7.6-9.831-12.971-9.866-13.025A1.332 1.332 0 0 1 371.022.6c.035.052 3.565 5.322 9.71 12.813a1.332 1.332 0 0 1-1.029 2.177",
    transform: "translate(-298.437 -.003)",
    style: {
      fill: "#333"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcEmptyCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-emptyCart.331807545dd17ea29eadb6cda9c2879b.svg";